module.exports = __webpack_public_path__ + "img/andriod.59f2de02.png";